import { render, staticRenderFns } from "./MainLearningContentsAssignment.vue?vue&type=template&id=ffbf9798"
import script from "./MainLearningContentsAssignment.vue?vue&type=script&lang=js"
export * from "./MainLearningContentsAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports